

const PropTypes = require('prop-types');

require('./brokerTransferPensionPlansDataSummary.scss');

// @vendors
const React = require('react');
const { formatText, getLanguage } = require('core/i18n').i18n;

//@ Utilities
const { formatAccountTextWithSpaces } = require('utilities/ibanHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @Components
const BrokerThreeContainerSummary = require('components/broker/brokerThreeContainerSummary/brokerThreeContainerSummary');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @Constants
const {
  BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT,
  BROKER_TRANSFER_PENSION_PLAN_TYPE_TOTAL_OPTION,
  BROKER_TRANSFER_PENSION_PLAN_FISC_A_OPTION,
  BROKER_TRANSFER_PENSION_PLAN_FISC_B_OPTION,
  BROKER_TRANSFER_PENSION_PLAN_FISC_C_OPTION
} = require('constants/index');
const language = getLanguage();

class BrokerTransferPensionPlansInternalSummary extends React.Component {

buildFiscalizationBlock(fiscalizationOption) {
    let fiscalizationMessage;
    switch (fiscalizationOption) {
      case BROKER_TRANSFER_PENSION_PLAN_FISC_A_OPTION:
        fiscalizationMessage = 'brokerTraspassBetweenMyPlans-step4FiscA';
        break;
      case BROKER_TRANSFER_PENSION_PLAN_FISC_B_OPTION:
        fiscalizationMessage = 'brokerTraspassBetweenMyPlans-step4FiscB';
        break;
      case BROKER_TRANSFER_PENSION_PLAN_FISC_C_OPTION:
        fiscalizationMessage = 'brokerTraspassBetweenMyPlans-step4FiscC';
        break;
      default:
        break;
    }

    return ([formatText('brokerTraspassBetweenMyPlans-step4Fisc'),
        formatText(fiscalizationMessage),'']);
  }

  buildThirdLine(title, value, isAmountType = false){

    let finalValue = value;

    if(isAmountType) {
        const plainAmountObject = getPlainAmountObject(value);
        finalValue = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
    }

    return(
        <span className="broker-transfer-pension-plans-internal-summary__third-line">
            {formatText(title)}{finalValue}
        </span>
    );
  }

buildPartialSummary(planData) {
    const summaryData = {
      leftContainer: [],
      middleContainer: [],
      rightContainer: []
    };

    const planContract = planData.get('fullContractNumber') ? planData.get('fullContractNumber') : null;
    const associatedAccount = planData.getIn(['associatedAccount', 'fullAccountNumber']) ? planData.getIn(['associatedAccount', 'fullAccountNumber']) : null;
    const formatAccount = associatedAccount ? formatAccountTextWithSpaces( associatedAccount, BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT) : '';
    const owner = planData.get('owner');
    const formatContract = planContract ? formatAccountTextWithSpaces( planContract, BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT) : '';
    const associatedAccountBalance = planData.get('associatedAccountBalance') ? planData.get('associatedAccountBalance'):null;
    const gestionEntity = planData.get('gestionEntity');
    const depositEntity = planData.get('depositEntity');
    const pensionFund = planData.get('pensionFund');

    const blockOwner = this.buildThirdLine('brokerTraspassBetweenMyPlans-commonOwner', owner);
    const blockBalanceAccount = this.buildThirdLine('brokerTraspassBetweenMyPlans-commonBalanceInAccount', associatedAccountBalance, true);

    if (planContract) {
        summaryData.leftContainer.push([formatText('brokerTraspassBetweenMyPlans-commonContractNumber'),
        formatContract, '',
        blockOwner]);
    }
    if (associatedAccount) {
        summaryData.leftContainer.push([formatText('brokerTraspassBetweenMyPlans-step1AssociatedAccount'),
        formatAccount, '',
        blockBalanceAccount]);
    }
    summaryData.middleContainer.push([formatText('brokerTraspassBetweenMyPlans-step1Gestor'),gestionEntity]);
    summaryData.middleContainer.push([formatText('brokerTraspassBetweenMyPlans-step1Entity'), depositEntity]);
    summaryData.middleContainer.push([formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step1PensionFund'), pensionFund]);

    return (
        <BrokerThreeContainerSummary
            extraClass="plan-data-column"
            data={summaryData}
        />
    )
}

buildCompleteSummary(originPlanData, destinationPlanData, options) {
    const { isExternalTransfer } = this.props;
    const summaryData = {
      leftContainer: [],
      middleContainer: [],
      rightContainer: []
    };
    const originPlanName = originPlanData.get('name');
    const originPlanValue = originPlanData.get('totalValueEur') ? originPlanData.get('totalValueEur'):null;
    const originPlanContract = originPlanData.get('fullContractNumber') ? originPlanData.get('fullContractNumber'):null; //ver si es traspaso externo. En tal caso no hay numero de contrato
    const extractName = isExternalTransfer ? originPlanData.get('fileAttachedName'):null;
    const originPlanAssociatedAccount = originPlanData.getIn(['associatedAccount', 'fullAccountNumber'])?originPlanData.getIn(['associatedAccount', 'fullAccountNumber']):null;  //ver si es traspaso externo. En tal caso no hay cuenta asociada
    const originPlanOwner = originPlanData.get('owner'); //ver
    const originPlanAccountBalance = originPlanData.get('associatedAccountBalance') ? originPlanData.get('associatedAccountBalance'):null; //ver si es traspaso externo. En tal caso no hay cuenta asociada
    const formatOriginAccount = originPlanAssociatedAccount ? formatAccountTextWithSpaces( originPlanAssociatedAccount, BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT) : ''; //ver si es traspaso externo. En tal caso no hay cuenta asociada
    const formatOriginContract = originPlanContract ? formatAccountTextWithSpaces( originPlanContract, BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT) : '';
    const originPlan = originPlanValue ? this.buildThirdLine('brokerDropdownFunds-value', originPlanValue, true):null;
    const originPlanBlockOwner = this.buildThirdLine('brokerTraspassBetweenMyPlans-commonOwner', originPlanOwner);
    let originPlanBalanceAccount;
    if (originPlanAccountBalance){
        originPlanBalanceAccount = this.buildThirdLine('brokerTraspassBetweenMyPlans-commonBalanceInAccount', originPlanAccountBalance, true);
    }


    summaryData.leftContainer.push([formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step1Title'),
        originPlanName, '',
        originPlan]);
    if (extractName){
      summaryData.leftContainer.push([formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_extractChosen'),
        extractName]);
    }
    if (originPlanContract){
        summaryData.leftContainer.push([formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_commonContractNumber'),
        formatOriginContract, '',
        originPlanBlockOwner]);
    }
    if (originPlanAccountBalance) {
        summaryData.leftContainer.push([formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step1AssociatedAccount'),
        formatOriginAccount, '',
        originPlanBalanceAccount]);
    }

    const destinationPlanIsValue = options.planInWallet;
    const destinationPlanName = destinationPlanData.get('name');
    const destinationPlanContract = destinationPlanIsValue? destinationPlanData.get('fullContractNumber'):null;
    const destinationPlanAssociatedAccount = destinationPlanData.getIn(['associatedAccount', 'fullAccountNumber']);
    const destinationPlanOwner = destinationPlanData.get('owner');
    const destinationPlanAccountBalance = destinationPlanData.get('associatedAccountBalance');
    const destinationPlanAssociatedData = destinationPlanIsValue ? destinationPlanData.get('totalValueEur'): destinationPlanData.get('DGSCode');
    const formatDestinationAccount = destinationPlanAssociatedAccount ? formatAccountTextWithSpaces( destinationPlanAssociatedAccount, BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT) : '';
    const formatDestinationContract = destinationPlanContract ? formatAccountTextWithSpaces( destinationPlanContract, BROKER_TRANSFER_PENSION_PLAN_ACCOUNT_FORMAT) : '';

    const destinationPlan = this.buildThirdLine(!destinationPlanIsValue ? 'brokerTraspassBetweenMyPlans-step2Code' : 'brokerDropdownFunds-value', destinationPlanAssociatedData, destinationPlanIsValue);
    const destinationPlanBlockOwner = this.buildThirdLine('brokerTraspassBetweenMyPlans-commonOwner', destinationPlanOwner);
    const destinationPlanBalanceAccount = this.buildThirdLine('brokerTraspassBetweenMyPlans-commonBalanceInAccount', destinationPlanAccountBalance, true);

    summaryData.middleContainer.push([formatText('brokerTraspassBetweenMyPlans-step2Title'),
        destinationPlanName, '',
        destinationPlan]);
    if(destinationPlanIsValue) {
      summaryData.middleContainer.push([formatText('brokerTraspassBetweenMyPlans-commonContractNumber'),
          formatDestinationContract, '',
          destinationPlanBlockOwner]);
    }
    summaryData.middleContainer.push([formatText('brokerTraspassBetweenMyPlans-step1AssociatedAccount'),
        formatDestinationAccount, '',
        destinationPlanBalanceAccount]);

    const transferTypeOption = options.selectedTypeOption;
    const partialTransferAmount = options.partialAportation;
    const fiscOption = options.selectedFiscOption;

    const transferTypeTotal = transferTypeOption === BROKER_TRANSFER_PENSION_PLAN_TYPE_TOTAL_OPTION ? true : false;
    const transferTypeBlock = transferTypeTotal ? '' : this.buildThirdLine('brokerDropdownFunds-value', partialTransferAmount, true);

    summaryData.rightContainer.push([formatText('brokerTraspassBetweenMyPlans-step4Type'),
        transferTypeTotal ? formatText('brokerTraspassBetweenMyPlans-step4Total') : formatText('brokerTraspassBetweenMyPlans-step4Partial'), '',
        transferTypeBlock]);
    summaryData.rightContainer.push(this.buildFiscalizationBlock(fiscOption));

    return (
        <BrokerThreeContainerSummary
            extraClass="plan-data-column"
            columns="4"
            data={summaryData}
        />
    )
  }

  buildSummary() {
    const {
      originPlanData,
      destinationPlanData,
      options
    } = this.props;

    let summary;

    if(!originPlanData || !destinationPlanData) {
        const planData = originPlanData ? originPlanData : destinationPlanData;
        summary = this.buildPartialSummary(planData);
    } else {
        summary = this.buildCompleteSummary(originPlanData, destinationPlanData, options);
    }

    return summary;
  }

  defineSummaryClass() {
    const {
      originPlanData,
      destinationPlanData
    } = this.props;

    return !originPlanData || !destinationPlanData ?
      "broker-transfer-pension-plans-internal-summary partial" :
      "broker-transfer-pension-plans-internal-summary complete";
  }

  render() {
    return (
        <div className={this.defineSummaryClass()}>
            {this.buildSummary()}
        </div>
    )
  }
}

BrokerTransferPensionPlansInternalSummary.propTypes = {
    originPlanData: PropTypes.object,
    destinationPlanData: PropTypes.object,
    isExternalTransfer: PropTypes.bool,
    options: PropTypes.object
}

module.exports = BrokerTransferPensionPlansInternalSummary;
